import React from 'react';
import { useUser } from '../../util/user';

export default function RouteProtect({ requiredRoles=[], children }) {
	// user data from keycloak
	const currentUser = useUser();
	const currentRoles = currentUser ? currentUser.roles : [];
	
	// check if user has at least one of the roles
	// NOTE: requiredRoles has this format: [['_GY:TH', '_GY:O&M], ['_GY:Base', '_CLIENT:Base']]
	// this means that the user must have at least one set of roles from requiredRoles in currentRoles
	//
	// const requiredRoles = [['_GY:TH', '_GY:O&M], ['_GY:Base', '_CLIENT:Base']];

	if(requiredRoles.some((roles) => roles.every((role) => currentRoles.includes(role)))) {
		return children;
	}

	return <p><b>Access Denied</b>: You don't have permission to view this content</p>;
};